import type { LocalizedText } from "@shared/locale/localized-text";

export const PRODUCT_NAME: LocalizedText = {
  ar: "نظام إدارة العيادات",
  en: "Clinic Management System",
  tr: "Klinik Yönetim Sistemi",
};
